'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = function () {
    var previewCellSelector = '.table-book-img-td';
    var bookTableElements = document.querySelectorAll(previewCellSelector);
    if (!bookTableElements) return;

    var previewIconSelector = '.table-book-img-preview';

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(bookTableElements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var previewCell = _step.value;

            if (previewCell.mouseEventsRegistered === true) continue;
            previewCell.addEventListener('mouseover', tableBookMouseOver);
            previewCell.addEventListener('mouseleave', tableBookMouseLeave);
            previewCell.mouseEventsRegistered = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    function tableBookMouseOver(event) {
        var tdElement = event.target;
        var row = tdElement.closest('tr');
        var imagePreview = tdElement.querySelector('.table-book-img-preview');

        if (!imagePreview || !row || this.offsetTop === 0) return;

        // clear all previous show classes
        [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(previewIconSelector))).forEach(function (e) {
            return e.classList.remove('show', 'bottom', 'top');
        });

        var elementPositionObject = this.getBoundingClientRect();
        var offsetBoundary = 200;
        var rowCount = row.parentElement.querySelectorAll(previewCellSelector).length;
        var boundaryItems = 4;

        imagePreview.classList.add('show');
        if (elementPositionObject.top < offsetBoundary || row.rowIndex < boundaryItems) imagePreview.classList.add('top');else if (window.innerHeight - elementPositionObject.top < offsetBoundary || row.rowIndex + boundaryItems > rowCount) imagePreview.classList.add('bottom');

        row.classList.add('max-z-index');
        event.stopPropagation();
    }

    function tableBookMouseLeave(event) {
        var element = event.target;

        var tr = element.closest('tr');
        if (tr) tr.classList.remove('max-z-index');

        var imagePreview = element.querySelector(previewIconSelector);
        if (imagePreview) imagePreview.classList.remove('show', 'bottom', 'top');
        event.stopPropagation();
    }
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/catalogCoverMouseover.js
// module id = 930
// module chunks = 0